/**
 * Created by Jerker Nord on 2024-01-10.
 */
import {LonerDuckAnimator} from "./LonerDuckAnimator";
import {Loner} from "../../../Loner";
import {LonerGameAssets} from "../../../LonerGameAssets";
import {LonerDuckSymbol} from "./symbols/LonerDuckSymbol";
import {gsap} from "gsap";
import {LonerGameMode} from "../../../server/LonerGameMode";
import {SYMBOL_NAMES} from "../../../../core/reel/ReelInterfaces";
import {LonerDuckMX2Symbol} from "./symbols/LonerDuckMX2Symbol";

export class LonerMiddleDuckAnimator extends LonerDuckAnimator {

    constructor() {
        super();
        this.DUCKS_Y_POS = -10;
        this.DUCKS_X_START_POS = -630;
        this.DUCK_INIT_REEL = 0;
        this.DUCK_INIT_ROW = 1;
        this._direction = LonerDuckAnimator.DIRECTION_RIGHT;
        this.BULLET_HOLE_POSITIONS = [new PIXI.Point(-186,-10), new PIXI.Point(86, -10)];
        this.init();
    }

    protected initBackground():void {
        this._background = new PIXI.Sprite(Loner.assetLoader.getTextures(LonerGameAssets.SSD_MIDDLE_BACKGROUND)[0]);
        this._background.anchor.set(0.5, 0.5);
        this.addChild(this._background);
    }

    public getMoveAllDucksTL():gsap.core.Timeline {
        if(this._moveDucksTL) {
            this._moveDucksTL.kill();
        }
        let ease:string = "none";
        this._duckMoveAmount = this._ducksContainer.position.x + (this.SPACE_BETWEEN_DUCKS + this.DUCK_WIDTH);//this._ducks[this._ducks.length - 1].width
        this._moveDucksTL = gsap.timeline({
            onComplete : () => this.onMoveAllDucksComplete(),
            onUpdate : () => this.onMoveDucksTLUpdate(),
            paused : this._isPaused
        });
        this._moveDucksTL.add(() => {
            for(let i:number = 0; i < this._ducks.length; i++) {
                if(this._ducks[i].symbolName == SYMBOL_NAMES.MX2) {
                    (<LonerDuckMX2Symbol>this._ducks[i]).movingDuck();
                    this._hasMX2Duck = true;
                } else {
                    this._ducks[i].movingDuck();
                }
            }
        });
        this._moveDucksTL.add(gsap.to(this._ducksContainer.position, {
            ease : ease,
            duration : this.DUCK_STEP_ANIMATION_DURATION,
            x : this._duckMoveAmount
        }));
        return this._moveDucksTL;
    }

    protected onMoveAllDucksComplete():void {
        Loner.ssdMainView.duckAnimatorCycleComplete(this.DUCK_INIT_ROW);
        this._mx2InfoUpdated = false;
        let removeDuck:LonerDuckSymbol = this._ducks.pop()!;
        this._ducksContainer.removeChild(removeDuck);
        this.doDuckReset(removeDuck);
        for(let i:number = 0; i < this._ducks.length; i++) {
            this._ducks[i].position.x += this._duckMoveAmount;
        }
        this._ducksContainer.position.x = 0;

        if(Loner.model.addDucksMiddleReel.length == 0) {
            if(Loner.model.data.nextMode == LonerGameMode.NORMAL) {
                //console.log("Middle ducks: End of FS");
            } else {
                //console.log("ERROR!! No middle reel ducks left!");
            }
        } else {
            this.startNewDuckMoveCycle();
        }
    }

    protected startNewDuckMoveCycle():void{
        this.addNextDuck();
        this._ducks[0].position.x = this._ducks[1].position.x - (this.SPACE_BETWEEN_DUCKS + this.DUCK_WIDTH);
        this.getMoveAllDucksTL();
    }

    public shootDuck(duckPosition:number, symbolName:string):void {
        super.shootDuck(duckPosition, symbolName);
    }

    protected addNextDuck():void {
        this._nextDuck = Loner.duckSymbolPool.getSymbol(Loner.model.addDucksMiddleReel[0].duckName,
            LonerDuckAnimator.DUCK_BASE_PATH + Loner.ssdMainView.getDuckValuePath(Loner.model.addDucksMiddleReel[0].multiplier, Loner.model.addDucksMiddleReel[0].duckName) +
            Loner.model.addDucksMiddleReel[0].duckName + this._direction,
            Loner.model.addDucksMiddleReel[0].multiplier);
        this._nextDuck.direction = this._direction;
        this._nextDuck.row = this.DUCK_INIT_ROW;
        this._nextDuck.reel = this.DUCK_INIT_REEL;
        this._nextDuck.setMultiplier(Loner.model.addDucksMiddleReel.shift()!.multiplier);
        this._ducks.unshift(this._nextDuck);
        this._ducksContainer.addChild(this._nextDuck);
    }
}